import React from 'react';
import { StethoscopeIcon, MapPinIcon, StarIcon } from 'lucide-react';
interface DoctorListProps {
  searchTerm: string;
  selectedDoctorId: number | null;
  onSelectDoctor: (id: number) => void;
}
const mockDoctors = [{
  id: 1,
  name: 'Dr. Sarah Johnson',
  specialization: 'Cardiologist',
  qualification: 'MD, FACC',
  rating: 4.8,
  consultations: 1250,
  locations: ['Main Clinic', 'North Branch'],
  status: 'Available',
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop'
}, {
  id: 2,
  name: 'Dr. Michael Chen',
  specialization: 'Neurologist',
  qualification: 'MD, PhD',
  rating: 4.9,
  consultations: 980,
  locations: ['Main Clinic'],
  status: 'Busy',
  image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=150&h=150&fit=crop'
}, {
  id: 3,
  name: 'Dr. Emily Davis',
  specialization: 'Pediatrician',
  qualification: 'MD, FAAP',
  rating: 4.7,
  consultations: 1450,
  locations: ['Main Clinic', 'South Branch'],
  status: 'Available',
  image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=150&h=150&fit=crop'
}, {
  id: 4,
  name: 'Dr. James Wilson',
  specialization: 'Orthopedic Surgeon',
  qualification: 'MS, FAAOS',
  rating: 4.6,
  consultations: 875,
  locations: ['Main Clinic', 'East Branch'],
  status: 'Available',
  image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=150&h=150&fit=crop'
}];
export function DoctorList({
  searchTerm,
  selectedDoctorId,
  onSelectDoctor
}: DoctorListProps) {
  const filteredDoctors = mockDoctors.filter(doctor => doctor.name.toLowerCase().includes(searchTerm.toLowerCase()) || doctor.specialization.toLowerCase().includes(searchTerm.toLowerCase()) || doctor.locations.some(loc => loc.toLowerCase().includes(searchTerm.toLowerCase())));
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-403">
      <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-404">
        <h3 className="font-semibold text-gray-900" data-id="element-405">
          All Doctors ({filteredDoctors.length})
        </h3>
      </div>
      <div className="divide-y divide-gray-200 max-h-[calc(100vh-300px)] overflow-y-auto" data-id="element-406">
        {filteredDoctors.map(doctor => <button key={doctor.id} onClick={() => onSelectDoctor(doctor.id)} className={`w-full p-4 text-left hover:bg-gray-50 transition-colors ${selectedDoctorId === doctor.id ? 'bg-purple-50 border-l-4 border-purple-600' : ''}`} data-id="element-407">
            <div className="flex items-start space-x-3" data-id="element-408">
              <img src={doctor.image} alt={doctor.name} className="w-12 h-12 rounded-full object-cover flex-shrink-0" data-id="element-409" />
              <div className="flex-1 min-w-0" data-id="element-410">
                <div className="flex items-center justify-between mb-1" data-id="element-411">
                  <h4 className="font-semibold text-gray-900 truncate" data-id="element-412">
                    {doctor.name}
                  </h4>
                  <span className={`px-2 py-1 text-xs font-medium rounded-full ${doctor.status === 'Available' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-413">
                    {doctor.status}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-1" data-id="element-414">
                  {doctor.specialization}
                </p>
                <p className="text-xs text-gray-500 mb-2" data-id="element-415">
                  {doctor.qualification}
                </p>
                <div className="flex items-center justify-between text-xs" data-id="element-416">
                  <div className="flex items-center space-x-1" data-id="element-417">
                    <StarIcon className="w-3 h-3 text-yellow-500 fill-current" data-id="element-418" />
                    <span className="font-medium" data-id="element-419">{doctor.rating}</span>
                    <span className="text-gray-500" data-id="element-420">
                      ({doctor.consultations})
                    </span>
                  </div>
                  <div className="flex items-center text-gray-500" data-id="element-421">
                    <MapPinIcon className="w-3 h-3 mr-1" data-id="element-422" />
                    <span data-id="element-423">{doctor.locations.length} locations</span>
                  </div>
                </div>
              </div>
            </div>
          </button>)}
      </div>
    </div>;
}